import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/icon-saumon.svg'


const _withScopeId = n => (_pushScopeId("data-v-6e313040"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-boite" }
const _hoisted_2 = { class: "boite" }
const _hoisted_3 = ["checked"]
const _hoisted_4 = { class: "boite b2" }
const _hoisted_5 = ["checked"]
const _hoisted_6 = {
  key: 0,
  class: "content-boite"
}
const _hoisted_7 = { class: "boite" }
const _hoisted_8 = ["checked"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "saumon-icon",
  src: _imports_0,
  alt: "saumon"
}, null, -1))
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", null, _toDisplayString(_ctx.$t('consigne')), 1),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.poisson) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addRemoveFishBasket && _ctx.addRemoveFishBasket(...args))),
            checked: _ctx.poisson
          }, null, 40, _hoisted_3), [
            [_vModelCheckbox, _ctx.poisson]
          ]),
          _createElementVNode("label", null, _toDisplayString(_ctx.$t('boite.poisson')), 1)
        ]),
        _createVNode(_component_font_awesome_icon, {
          icon: "fish",
          class: "ico fish"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", null, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.gibier) = $event)),
            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addRemoveGibierBasket && _ctx.addRemoveGibierBasket(...args))),
            checked: _ctx.gibier
          }, null, 40, _hoisted_5), [
            [_vModelCheckbox, _ctx.gibier]
          ]),
          _createElementVNode("label", null, _toDisplayString(_ctx.$t('boite.gibier')), 1)
        ]),
        _createVNode(_component_font_awesome_icon, {
          icon: "deer",
          class: "ico gibier"
        })
      ])
    ]),
    (_ctx.getAge() >= 75)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.saumon) = $event)),
                onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addRemoveSaumonBasket && _ctx.addRemoveSaumonBasket(...args))),
                checked: _ctx.saumon
              }, null, 40, _hoisted_8), [
                [_vModelCheckbox, _ctx.saumon]
              ]),
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('boite.saumon')), 1)
            ]),
            _hoisted_9
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      class: _normalizeClass(["btn-demande", { isActive: !_ctx.isDisabled }]),
      disabled: _ctx.isDisabled,
      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.goToConfimation && _ctx.goToConfimation(...args)))
    }, [
      _createVNode(_component_font_awesome_icon, {
        icon: [_ctx.ico, 'box-circle-check']
      }, null, 8, ["icon"]),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('faireDemande')), 1)
    ], 10, _hoisted_10)
  ], 64))
}